const permissionStaff = {
  '7': '商店擁有者',
  '8': '商店管理',
  '12': '分店管理'
}
const permissionList = [
  { item: '操作行事曆', groupIds: [7, 8, 9, 10, 12] },

  { item: '入場報到', groupIds: [7, 8, 9, 10, 11, 12] },

  { item: '操作加購', groupIds: [7, 8, 9, 10, 11, 12] },

  { item: '操作訂單管理', groupIds: [7, 8, 9, 10, 12] },

  { item: '操作客戶管理', groupIds: [7, 8, 9, 10, 12] },

  { item: '操作優惠券(進階方案)', groupIds: [7, 8, 9, 10, 12] },

  { item: '操作包月方案', groupIds: [7, 8, 9, 12] },

  { item: '操作排班', groupIds: [7, 8, 12] },

  { item: '操作排班人員', groupIds: [7, 8, 12] },

  { item: '操作管理帳號', groupIds: [7, 8, 12] },

  { item: '查看數據分析', groupIds: [7, 8, 12] },

  { item: '新增/修改分店', groupIds: [7, 8, 12] },

  { item: '編輯商店資訊', groupIds: [7, 8] },

  { item: '編輯通知設定', groupIds: [7, 8] },

  { item: '查看簡訊紀錄', groupIds: [7, 8] },

  { item: '方案訂閱管理/訂閱付費紀錄', groupIds: [7] },
]

export default permissionList
